import { Link } from 'react-router-dom';
import { useAuthStore } from '../store/authStore';

export default function UserMenu() {
  const user = useAuthStore((s) => s.user);
  const logout = useAuthStore((s) => s.logout);

  if (!user) return null;

  return (
    <div className="flex items-center gap-3">
      {user.role === 'admin' && (
        <Link
          to="/admin/users"
          className="btn-ghost hidden px-3 py-1.5 text-xs sm:inline-flex"
        >
          Users
        </Link>
      )}
      <span className="hidden max-w-[10rem] truncate text-xs text-text-muted sm:inline">
        {user.display_name}
      </span>
      <button
        type="button"
        onClick={() => void logout()}
        className="btn-ghost px-3 py-1.5 text-xs"
      >
        Log out
      </button>
    </div>
  );
}
